import { resolveApiUrl } from "../../../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/cart/delete/product/{productCode}");

export function apiDeleteProduct(productCode: string): Promise<void> {
  let finalUrl = apiUrl;
  finalUrl = finalUrl.replace("{productCode}", productCode);
  return fetch(finalUrl, {
    method: "DELETE",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error("Error when deleting product");
      }
    })
    .then((result) => {
      window.SCHA.updateMinicart?.();
      return result;
    });
}
